import React, { useContext } from "react";
import { CacheStoreContext } from "../../reactcontext/cache-store-context";

export function useMemCache() {
    const cacheCtx = useContext(CacheStoreContext);
    return cacheCtx.storeByName;
}

export function useMemObjCache<KEY, VAL>(name: string): Map<KEY, VAL>{
    const wholeCache = useMemCache();

    if(!wholeCache.has(name))
        wholeCache.set(name, new Map<any, any>());

    return wholeCache.get(name);
}


